import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import FrDatePicker from '../components/FrDatePicker'
import Dialog from '@material-ui/core/Dialog';
import { colors } from '../utils/vars'
import FrTextInput from '../components/FrTextInput'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty, getSedeCode, getUserCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Debito_Conta(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboUsu, setComboUsu] = useState([{ value: '', display: '' }])
  const [showModal, setShowModal] = useState(false)
  const [data_inicial, setData_Inicial] = useState('')
  const [data_final, setData_Final] = useState('')
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])

  const [fk_fpg1, setFpg1] = useState(0)
  const [fk_fpg2, setFpg2] = useState(0)
  const [fk_fpg3, setFpg3] = useState(0)
  const [fk_fpg4, setFpg4] = useState(0)
  const [fk_fpg5, setFpg5] = useState(0)
  const [fk_fpg6, setFpg6] = useState(0)
  const [fk_fpg7, setFpg7] = useState(0)

  const [nomeFpg1, setNome1] = useState('')
  const [nomeFpg2, setNome2] = useState('')
  const [nomeFpg3, setNome3] = useState('')
  const [nomeFpg4, setNome4] = useState('')
  const [nomeFpg5, setNome5] = useState('')
  const [nomeFpg6, setNome6] = useState('')
  const [nomeFpg7, setNome7] = useState('')

  const [lote1, setLote1] = useState('')
  const [lote2, setLote2] = useState('')
  const [lote3, setLote3] = useState('')
  const [lote4, setLote4] = useState('')
  const [lote5, setLote5] = useState('')
  const [lote6, setLote6] = useState('')
  const [lote7, setLote7] = useState('')

  const columns = [
    { id: 'data_geracao', date: true, numeric: false, label: 'Data Geração', align: 'left', minWidth: 50 },
    { id: 'nomeusu', numeric: false, label: 'Usuário', align: 'left', minWidth: 100 },
    { id: 'nomefpg', numeric: false, label: 'Banco/Conta', align: 'left', minWidth: 100 },
    { id: 'data_inicial', date: true, numeric: false, label: 'Data Inicial', align: 'left', minWidth: 50 },
    { id: 'data_final', date: true, numeric: false, label: 'Data Final', align: 'left', minWidth: 50 },
    { id: 'total_registros', numeric: false, label: 'Total Registros', align: 'left', minWidth: 50 },

  ]

  let fpg1 = 25
  let fpg2 = 29
  let fpg3 = 24
  let fpg4 = 21
  let fpg5 = 30
  let fpg6 = 23
  let fpg7 = 22

  // 25 - ITAU CLUBE
  // 29 - SANTANDER
  // 24 - BB
  // 21 - BANRISUL
  // 30 - ITAÚ VIDA
  // 23 - BRADESCO
  // 22 - CEF

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      let tela = 'Cobrança Débito Conta'
      setenableAdd(await api.getAcessos(tela, 'Inclusao'))
      setenableEdit(await api.getAcessos(tela, 'Alteracao'))
      setenableDel(await api.getAcessos(tela, 'Exclusao'))

      setComboUsu(await api.getComboData('usuarios'))
      let fpg = await api.getComboDataWhere('formas_pagamento', "?pk_fpg=" + fpg1 + ',' + fpg2 + ',' + fpg3 + ',' + fpg4 + ',' + fpg5 + ',' + fpg6 + ',' + fpg7)
      setComboFpg(fpg)

      try {
        let fpgs = await api.getComboDataWhere('formas_pagamento', "?pk_fpg=" + fpg1)
        setNome1(fpgs[0].display)
        setLote1(fpgs[0].lote)

        fpgs = await api.getComboDataWhere('formas_pagamento', "?pk_fpg=" + fpg2)
        setNome2(fpgs[0].display)
        setLote2(fpgs[0].lote)

        fpgs = await api.getComboDataWhere('formas_pagamento', "?pk_fpg=" + fpg3)
        setNome3(fpgs[0].display)
        setLote3(fpgs[0].lote)

        fpgs = await api.getComboDataWhere('formas_pagamento', "?pk_fpg=" + fpg4)
        setNome4(fpgs[0].display)
        setLote4(fpgs[0].lote)

        fpgs = await api.getComboDataWhere('formas_pagamento', "?pk_fpg=" + fpg5)
        setNome5(fpgs[0].display)
        setLote5(fpgs[0].lote)

        fpgs = await api.getComboDataWhere('formas_pagamento', "?pk_fpg=" + fpg6)
        setNome6(fpgs[0].display)
        setLote6(fpgs[0].lote)

        fpgs = await api.getComboDataWhere('formas_pagamento', "?pk_fpg=" + fpg7)
        setNome7(fpgs[0].display)
        setLote7(fpgs[0].lote)

      } catch (error) {

      }

      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    if (!isEmpty(queryObject)) {
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/salute/debito_conta?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/controle_cobranca', { params: queryObject }).then(r => {
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire({
        title: 'Nenhum filtro informado!',
        html: '<p>Informe ao menos um filtro para realizar a busca.',
        icon: 'warning'
      })

    }
  }

  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/debito_conta');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  function geraCobranca(e) {
    e.preventDefault();
    setData_Inicial('')
    setData_Final('')
    setShowModal(true)
  }

  function confirmaModal(e) {
    e.preventDefault();
    let fk_fpg = fk_fpg1 + ',' + fk_fpg2 + ',' + fk_fpg3 + ',' + fk_fpg4 + ',' + fk_fpg5 + ',' + fk_fpg6 + ',' + fk_fpg7
    let lotes = lote1 + ',' + lote2 + ',' + lote3 + ',' + lote4 + ',' + lote5 + ',' + lote6 + ',' + lote7


    // alert(fk_fpg.length)
    if ((data_inicial) && (data_final) && (fk_fpg.length > 0)) {
      api.post('/controle_cobranca/geraCobranca?fk_usu=' + getUserCode() + '&data_inicial=' + data_inicial + '&data_final=' + data_final + '&fk_fpg=' + fk_fpg + '&lotes=' + lotes).then(r => {
        if (r.status === 200) {
          console.log(r)
          if (r.data.gerou) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Arquivo gerado!<h2>`,
              html: `<p style='color: ${colors.info900}'>Arquivo gerado com sucesso!</p>`,
              icon: 'success',
            }).then((result) => {
              if (result.value) {
                setShowModal(false)
                const auxValues = { ...filter };
                auxValues.data_inicial = new Date()
                auxValues.data_final = new Date()
                setFilter(auxValues);

                window.location.reload()
              }
            })
          } else {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color: ${colors.info900}'>Não gerado!<h2>`,
              html: `<p style='color: ${colors.info900}'>Não foram encontrados registros para geração!</p>`,
              icon: 'warning',
            })
          }
        }
      })
    } else
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        title: 'Informe as datas e os bancos a gerar!',
        html: '<p>Informe o período de vencimento e os bancos a gerar!',
        icon: 'warning'
      })

  }

  function fechaModal(e) {
    e.preventDefault();
    setShowModal(false)
  }

  const handleChange = (e) => {
    if (e.target.name == 'fk_fpg1')
      setFpg1(fk_fpg1 === 0 ? fpg1 : 0)
    else
      if (e.target.name == 'fk_fpg2')
        setFpg2(fk_fpg2 === 0 ? fpg2 : 0)
      else
        if (e.target.name == 'fk_fpg3')
          setFpg3(fk_fpg3 === 0 ? fpg3 : 0)
        else
          if (e.target.name == 'fk_fpg4')
            setFpg4(fk_fpg4 === 0 ? fpg4 : 0)
          else
            if (e.target.name == 'fk_fpg5')
              setFpg5(fk_fpg5 === 0 ? fpg5 : 0)
            else
              if (e.target.name == 'fk_fpg6')
                setFpg6(fk_fpg6 === 0 ? fpg6 : 0)
              else
                if (e.target.name == 'fk_fpg7')
                  setFpg7(fk_fpg7 === 0 ? fpg7 : 0)
                else
                  if (e.target.name == 'lote1')
                    setLote1(e.target.value)
                  else
                    if (e.target.name == 'lote2')
                      setLote2(e.target.value)
                    else
                      if (e.target.name == 'lote3')
                        setLote3(e.target.value)
                      else
                        if (e.target.name == 'lote4')
                          setLote4(e.target.value)
                        else
                          if (e.target.name == 'lote5')
                            setLote5(e.target.value)
                          else
                            if (e.target.name == 'lote6')
                              setLote6(e.target.value)
                            else
                              if (e.target.name == 'lote7')
                                setLote7(e.target.value)
                              else
                                if (e.target.name == 'data_inicial')
                                  setData_Inicial(e.target.value)
                                else
                                  if (e.target.name == 'data_final')
                                    setData_Final(e.target.value)
                                  else {
                                    const auxValues = { ...filter };
                                    switch (e.target.name) {
                                      default:
                                        auxValues[e.target.name] = e.target.value;
                                    }
                                    setFilter(auxValues);
                                  }
  };


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Cobrança Débito em Conta</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrSelect
                value={filter.fk_usu || -1}
                style={{ width: 150 }}
                name="fk_usu"
                id="fk_usu"
                label='Usuário'
                data={comboUsu}
                onChange={handleChange}
                mostraTodos
              />

              <FrSelect
                value={filter.fk_fpg || -1}
                style={{ width: 250 }}
                name="fk_fpg"
                id="fk_fpg"
                label='Banco/Conta'
                data={comboFpg}
                onChange={handleChange}
                mostraTodos
              />

              <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período Geração"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                name="datafim"
                id="datafim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <button style={{ width: '200px' }} onClick={geraCobranca}>
                  <Icon icon={ic_add_box} size={18} />
                  Gerar Débito em Conta
                </button>
              }

            </div>
          </form>
        </div>
        <br />

        <div>
          <Dialog aria-labelledby="simple-dialog-title" open={showModal} maxWidth={'lg'}>
            <div className="modalContent">

              <FrDatePicker
                value={(data_inicial || '').split('T')[0]}
                name="data_inicial"
                id="data_inicial"
                color="#49573B"
                label="Período Vencimento"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
                autoFocus
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(data_final || '').split('T')[0]}
                name="data_final"
                id="data_final"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <br />
              <div className='divLote'>
                <FormControlLabel className='divLabel'
                  control={
                    <Checkbox
                      name='fk_fpg1'
                      id='fk_fpg1'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={fk_fpg1 == fpg1}
                    />
                  }
                  label={nomeFpg1}
                />

                <FrTextInput
                  maxLength='10'
                  value={lote1 || ''}
                  onChange={handleChange}
                  name="lote1"
                  id="lote1"
                  color="#389492"
                  label="Lote"
                  variant="outlined"
                  size="small"
                  style={{ width: 60, marginTop: '5px' }}
                />
              </div>

              <div className='divLote'>
                <FormControlLabel className='divLabel'
                  control={
                    <Checkbox
                      name='fk_fpg2'
                      id='fk_fpg2'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={fk_fpg2 == fpg2}
                    />
                  }
                  label={nomeFpg2}
                />
                <FrTextInput
                  maxLength='10'
                  value={lote2 || ''}
                  onChange={handleChange}
                  name="lote2"
                  id="lote2"
                  color="#389492"
                  label="Lote"
                  variant="outlined"
                  size="small"
                  style={{ width: 60, marginTop: '5px' }}
                />
              </div>

              <div className='divLote'>
                <FormControlLabel className='divLabel'
                  control={
                    <Checkbox
                      name='fk_fpg3'
                      id='fk_fpg3'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={fk_fpg3 == fpg3}
                    />
                  }
                  label={nomeFpg3}
                />
                <FrTextInput
                  maxLength='10'
                  value={lote3 || ''}
                  onChange={handleChange}
                  name="lote3"
                  id="lote3"
                  color="#389492"
                  label="Lote"
                  variant="outlined"
                  size="small"
                  style={{ width: 60, marginTop: '5px' }}
                />
              </div>
              <div className='divLote'>
                <FormControlLabel className='divLabel'
                  control={
                    <Checkbox
                      name='fk_fpg4'
                      id='fk_fpg4'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={fk_fpg4 == fpg4}
                    />
                  }
                  label={nomeFpg4}
                />
                <FrTextInput
                  maxLength='10'
                  value={lote4 || ''}
                  onChange={handleChange}
                  name="lote4"
                  id="lote4"
                  color="#389492"
                  label="Lote"
                  variant="outlined"
                  size="small"
                  style={{ width: 60, marginTop: '5px' }}
                />
              </div>
              <div className='divLote'>
                <FormControlLabel className='divLabel'
                  control={
                    <Checkbox
                      name='fk_fpg5'
                      id='fk_fpg5'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={fk_fpg5 == fpg5}
                    />
                  }
                  label={nomeFpg5}
                />
                <FrTextInput
                  maxLength='10'
                  value={lote5 || ''}
                  onChange={handleChange}
                  name="lote5"
                  id="lote5"
                  color="#389492"
                  label="Lote"
                  variant="outlined"
                  size="small"
                  style={{ width: 60, marginTop: '5px' }}
                />
              </div>
              <div className='divLote'>
                <FormControlLabel className='divLabel'
                  control={
                    <Checkbox
                      name='fk_fpg6'
                      id='fk_fpg6'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={fk_fpg6 == fpg6}
                    />
                  }
                  label={nomeFpg6}
                />
                <FrTextInput
                  maxLength='10'
                  value={lote6 || ''}
                  onChange={handleChange}
                  name="lote6"
                  id="lote6"
                  color="#389492"
                  label="Lote"
                  variant="outlined"
                  size="small"
                  style={{ width: 60, marginTop: '5px' }}
                />
              </div>
              <div className='divLote'>
                <FormControlLabel className='divLabel'
                  control={
                    <Checkbox
                      name='fk_fpg7'
                      id='fk_fpg7'
                      size='small'
                      color="primary"
                      onChange={handleChange}
                      checked={fk_fpg7 == fpg7}
                    />
                  }
                  label={nomeFpg7}
                />
                <FrTextInput
                  maxLength='10'
                  value={lote7 || ''}
                  onChange={handleChange}
                  name="lote7"
                  id="lote7"
                  color="#389492"
                  label="Lote"
                  variant="outlined"
                  size="small"
                  style={{ width: 60, marginTop: '5px' }}
                />
              </div>

            </div>

            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">
                <button onClick={confirmaModal}> Confirmar </button>
                <button onClick={fechaModal}> Sair </button>
              </div>
            </div>

          </Dialog>
        </div>


        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable
            startOrderBy={'data_geracao'}
            debito_conta width={50}
            regName="debito_conta"
            frame={props.frame}
            columns={columns}
            searched={filtered} codeName="pk_ccb" page={'debito_conta'} data={data} />

        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Debito_Conta;